import {$, HttpBody, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'
import Responsavel from '@/model/resource/Responsavel'

export default class MotoristaEResponsaveisRequest extends Resource {
  $id = 0
  readonly $name: string = 'MotoristaEResponsaveisRequest'
  readonly $endpoint: string = '/user/motorista{/id}'

  @ResponseSerialize(Motorista)
  motorista = new Motorista()

  @ResponseSerialize(Responsavel)
  responsaveis: Responsavel[] = []

  async listResponsaveis(motoristaId: number|string = '', spinner = 'listResponsaveis') {
    // TODO: arrumar no simpli-web-sdk
    // @ts-ignore
    const fetch = async () => await new HttpBody<Responsavel[]>(Responsavel)
      .GET(`/user/motorista/${motoristaId}/responsavel`)
    const resp = await $.await.run(fetch, spinner)
    this.responsaveis = resp.data
  }
}
